// extracted by mini-css-extract-plugin
export default {"select_wrapper":"GaitTest_select_wrapper__+4eRY","select_root":"GaitTest_select_root__RKjxx"};